<template>
  <div>
    <div class="login-card">
      <div class="login-card-header">
        <a href="https://www.parcelex.com.br/" class="brand" title="Parcelex">
          <img alt="Logo Parcelex" src="https://cdn.parcelex.com.br/assets/v2/website/parcelex-logo-color-dark.svg">
        </a>
        <h2>
          Faça sua aplicação de crédito
        </h2>
        <p class="text-gray-500">
          Vimos que você ainda não possui uma conta.
        </p>
      </div>
      <sign-up-form />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import SignUpForm from './SignUpForm.vue';
import ParcelexApi from '../../../services/parcelex';

export default ({
  name: 'SignUpCard',
  components: {
    SignUpForm,
  },
  methods: {
    ...mapActions('tracking', ['setTheTrackId', 'setTrackId']),
    ...mapState('tracking', ['trackId']),
    async sendEvent({ action, data }) {
      ParcelexApi.post('public/event/send', {
        action,
        source: 'login',
        origin: window.location.href.split('?')[0],
        data,
      }).catch((e) => console.error(e));
    },
  },
  computed: {
    ...mapGetters({ getTrackId: 'tracking/getTrackId' }),
  },
  created() {
    const { trackId } = this.$route.query;
    this.setTheTrackId(trackId);
  },
  async mounted() {
    if (this.trackId) {
      this.sendEvent({
        action: 'visualizou',
        data: {
          trackId: this.trackId,
          ctaSignInShowed: true,
        },
      });
    }
  },
});
</script>

<style lang="scss" scoped>
  *, *::before, *::after {
    box-sizing: border-box;
  }

  .text-gray-500 {
    color: var(--color-gray-500);
  }

  .login-card {
    background-color: white;
    width: 100%;
    max-width: 420px;
    border-radius: 1.5rem;
    padding: 24px;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    box-shadow: var(--shadow-elevation-high);

    @media (min-width: $md) {
      margin-top: 3rem;
      padding: 36px;
    }
  }

  .brand {
    display: inline-block;
    margin-bottom: .5rem;
  }

  .login-card-header {
    margin-bottom: 1.25rem;
  }

  .login-card {
    h2 {
      margin-bottom: .5rem;
    }
  }

  .container-input{
    margin-top: 1.25rem
  }

  .form-label{
    margin-bottom: 0.25rem;
    display: inline-block;
    font-weight: 600;
  }
  .login-button {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.5rem;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    color: var(--white);
    background-color: var(--color-primary);
    border-radius: 0.375rem;
    border-color: transparent;
    height: 56px;

    &:hover {
      background-color: var(--color-primary-600) !important;
      border-color: transparent;
    }

    @media (min-width: $md) {
      height: 42px;
    }
  }
</style>
